import React from "react";
import styled from "styled-components";
import Styles from "@themes/Styles";
import AppModeDropdown from "../../app/LifeAtApp/TopNavigation/TopNavigationComponents/AppModeDropdown";

const TopNavigationContainer = styled.div`
    display: flex;
    align-items: center;
    min-height: ${Styles.topBarHeight};
    width: 100%;
    background-color: ${(props) => props.theme.backgroundPrimary};
    border-bottom: 1px solid ${(props) => props.theme.borderPrimary};
    padding: 5px;
`;

function ExploreTopNavigation() {
    return (
        <TopNavigationContainer>
            <AppModeDropdown />
        </TopNavigationContainer>
    );
}

export default ExploreTopNavigation;
